<template>
  <div>
     <div class="container-fluid" style="overflow: hidden;">
      <div class="mb-3" :class="{'section-loading': infoLoading}" style="overflow: hidden;max-height: 140px;">
        <div class="float-left  w-75 pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">{{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}  <i v-if="categoryInfo.upload_file =''" class="icon-attach text-orange ml-2"></i><span style="font-size: medium;color: black;">{{ categoryInfo.upload_file | removeExten }}</span></h4>
          <div class="mb-line" style=""><span class="font-weight-bold mr-2">{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span></div>
          <div class=""><span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span></div>
        </div>
        <div class="float-left  w-25">
          <div class="mb-line"><span class="font-weight-bold mr-2">維護單位</span> <span>{{ categoryInfo.dev_name }}</span></div>
          <div class=""><span class="font-weight-bold mr-2">聯絡電話</span> <span>{{ categoryInfo.contact }}</span></div>
          <div class="mb-line"><span class="font-weight-bold mr-2">聯絡分機</span> <span>{{ categoryInfo.contact_tel }}</span></div>
           <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
            type="button"
            style="height:43px;"
            @click="backToIndex"
            class="position-absolute btn btn-default m-0"
            v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
          ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <precision-marketing-data-table
        :height="data_table_height"
        @update="updateSelection"
        @comment-modal="commentModal"
        @jump-to-customer="jumpToCustomer"
        @scheduled-access="ScheduledAccess"
        :table-data="tableData"/>
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12">
        </div>
        <div class="col-9 col-sm-8 col-md-8">
          <div class="list inline">
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">要</span>
              <small class="text">壽險要保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">被</span>
              <small class="text">壽險主被保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">意</span>
              <small class="text">意外被保險人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">團</span>
              <small class="text">團險被保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">借</span>
              <small class="text">房貸借款人</small>
            </div>
          </div>
        </div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button class="btn btn-primary"
          @click="panelOpen('groupModalOpen')"
          :disabled="!selection.length">
            加入群組
          </button>
          <button class="btn btn-primary mr-0"
          @click="panelOpen('printModalOpen')"
          :disabled="!selection.length">
            列印名條
          </button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal
    :open="printModalOpen"
    :custs="selection"
    @close="panelClose('printModalOpen')"/>

    <!-- 加入群組 -->
    <group-modal
    :open="groupModalOpen"
    :custs="selection"
    @submit="submitGroup"
    @close="panelClose('groupModalOpen')"/>

    <comment-modal 
        :open="commentModalOpen"
        :comment="comment"
        @close="panelClose('commentModalOpen')"
    />

    <satisfaction-modal 
        :open="satisfactionModalOpen"
        @report="report"
        @close="panelClose('satisfactionModalOpen')"
    />

    <scheduled-access
    :open="ScheduledAccessModalOpen"
    :record="currentRecord"
    :cat-info="categoryInfo"
    @close="panelClose('ScheduledAccessModalOpen')"
    @submit="submitScheduledAccess"
    />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'
import PrintModal from '@/desktop/components/PrintModal'
import GroupModal from '@/desktop/components/GroupModal'
import PrecisionMarketingDataTable from '../DataTable/PrecisionMarketingDataTable'
import CommentModal from '../CommentModal'
import SatisfactionModal from '../SatisfactionModal'
import { getCathayWithYourHealth, getCategoryDetail , isSatisfactionSurveyFinish, queryVisitEventLog } from '@/service'
import ScheduledAccess from '../ScheduledAccess'

export default {
  name: 'CathayWithYourHealth',
  mixins: [commonMixin],
  components: {
    PrecisionMarketingDataTable, 
    CommentModal, 
    SatisfactionModal,
    PrintModal,
    GroupModal,
    ScheduledAccess,  
  },
  props: {
    status: String,
  },
  computed: {
    
  },
  data () {  //data block layout
    return {
      currentPage: 0,
      isLoading: false,
      isLoading_btn: false,
      isBtnEnble: true,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      commentModalOpen: false,
      satisfactionModalOpen: false,
      comment: '',
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      categoryInfo: {},
      currentRecord: {},
      edit_access_index: 0,
      edit_access_name: '',
      dateFormatter: (date) => {
        const m = date.getMonth() + 1
        const d = date.getDate()
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
      info: {}
    }  
  },
  methods: {
    ...mapActions([
      'setPageLock', 'updateCustID'
    ]),
    updateSelection (val) {
      this.selection = val
    },
    commentModal(comment) {
        this.comment = comment
        this.panelOpen('commentModalOpen');
    },
    satisfactionModal() {
        this.panelOpen('satisfactionModalOpen');
    },
    report() {
        this.$toast.info({title:'滿意度調查 已回報'});
        this.isBtnEnble = false
        this.panelClose('satisfactionModalOpen')
    },
    jumpToCustomer(index) {  // 導頁到客戶資料
      this.updateCustID(index)
      localStorage.CustID = index
      this.$router.push({path: `/detail/CustID/tab/1`})
    },
    backToIndex() {  // 回上一頁
      this.$emit('change-status', 'STATUS_GROUP_RELATED_LIST');
    },
    submitGroup (group) {  // 加入群組導頁至 群組列表
      this.panelClose('groupModalOpen')
      this.$router.push({path:`/group/1`, query:{grp_id: group.grp_id, grp_name: group.grp_name}})
    },
    formatVIP (val) {  //  轉換 VIP code
      const filterData = [
        {name: '5', code: '黃金'},
        {name: '6', code: '白金'},
        {name: '7', code: '鑽石'},
      ]
      let reData = ''
      filterData.forEach(item => {
        if(val == item.code) {
          reData = item.name
        }
      })
      return reData
    },
    idmarkFormat (obj) {  //  轉換 idmark code
      if(typeof obj == 'object') {
        let data = []
        for (let index in obj) {
          if(obj[index] == '1'){
            data.push(index.substr(-1))
          }
        }
        return data
      }else{
        return ["N","N","N","N","N","N"]
      }
    },
    checkIsSatisfactionSurveyFinish () {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true
      isSatisfactionSurveyFinish(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        if(result.header && result.header.status == '200') {
          this.isBtnEnble = result.body.isfinish == '0' 
        } else {
          if(result.header && result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '查詢滿意度調查失敗,請重新操作'})
          }
        }
        this.isLoading_btn = false
      })
    },
    alreadyDone() {
      this.$toast.info({title: '您已回報過滿意度調查,無法重複操作'})
    },
    initCathayWithYourHealth () {  // 資料初始化
      this.checkIsSatisfactionSurveyFinish()
      // 取得列表資料
      this.isLoading = true
      queryVisitEventLog(this.$store.state.userInfo.id).then(visitData => {
        if(visitData.header && visitData.header.status === '200') {
          let visitList = visitData.body.events
          getCathayWithYourHealth(this.$store.state.userInfo.id).then(result => {
            this.isLoading = false
            if(result.header && result.header.status === '200') {
              this.tableData = result.body.detail.map(item => {
                let visit = {visit: {}}
                visitList.forEach(vItem => {
                  if(vItem.id == item.csidno) {
                    visit.visit = vItem
                  }
                })
                let ageText = this.paddingLeft(item.age == "0" ? "0" : item.age ? item.age : "00000", 4, "0");
                let birthdayText = item.csbrdy || "0000-01-01";
                return {
                  name: item.csname || '',
                  index: item.csidno || '',
                  id: item.csidno || '',
                  vip_level: this.formatVIP(item.vip),  //  轉換 VIP code
                  sex: Number(item.csidno[1]),
                  mobile: item.csmtel || '',
                  birthday: item.csbrdy || '',
                  age: item.age || '',
                  birthdaySort : ageText + "_" + birthdayText, //生日排序用
                  record: item.previous_date || '',
                  relationship: item.record_agcsrt || '',
                  idmark : this.idmarkFormat(item.idmark),  //  轉換 idmark code
                  visit_time: item.visit_time,
                  recordInfo: {},
                  ...visit, // 寫入排訪資料
                }
              })
              this.registerHanlink()  // for hard word
            }
          })
        }
      })

      // 取得專區資訊
      this.getTitleInfo()
    },
    getTitleInfo () { // 取得專區資訊
      this.infoLoading = true
      getCategoryDetail(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        this.infoLoading = false
        if(result.header && result.header.status == '200'){
          this.categoryInfo = result.body[0]
        }
      })
    },
    ScheduledAccess(index) {
      this.edit_access_index = index
      this.currentRecord = this.tableData[index]
      this.panelOpen('ScheduledAccessModalOpen')
    },
    submitScheduledAccess() {
      this.panelClose('ScheduledAccessModalOpen')
      // 資料初始化
      this.initCathayWithYourHealth()
    }
  },
  mounted () {
    // 資料初始化
    this.initCathayWithYourHealth()
    
    this.data_table_height = parseInt($(window).height()) - $('tbody').offset().top - 80
    let self = this;
    $(window).bind('orientationchange', function(event) {
      self.data_table_height = parseInt($(window).height()) - $('tbody').offset().top - 80;
    });
    $(".tab-content").css("padding-bottom","74px");
  }
}
</script>
